import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css
import '@/styles/common.scss' // common css
import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import * as filters from './filters' // global filters
import Viewer from 'v-viewer'
import VueClipboard from 'vue-clipboard2'

import Quill from "quill";
import ImageResize from "quill-image-resize-module";
import {ImageDrop} from 'quill-image-drop-module';

import rate from 'vue-rate'
import 'vue-rate/dist/vue-rate.css'
import 'element-ui/lib/theme-chalk/display.css'
import i18n from './i18n';

Quill.register("modules/imageResize", ImageResize);
Quill.register('modules/imageDrop', ImageDrop);

Vue.use(rate)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  }
})

Vue.use(Element, {
  i18n: (key, value) => {
    return i18n.t(key, value);
  }, // 设置 Element UI 的国际化处理方法
  size: Cookies.get('size') || 'medium', // set element-ui default size
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  i18n,
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/admin/main.js